import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface CashSettlementDateFieldProps {}

export const CashSettlementDateField: React.FC<CashSettlementDateFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ cash_settlement_payment_date: string }>()

  return (
    <FormField
      name="cash_settlement_payment_date"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Cash Sett Payment Date</FormLabel>
              <FormError />
            </div>
            <DatePicker
              placeholder={'Choose a date'}
              selected={value ? new Date(value) : undefined}
              onSelect={(date) =>
                date &&
                setValue('cash_settlement_payment_date', toISO8601(date), {
                  shouldValidate: true,
                })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
